module.exports = __webpack_public_path__ + "static/media/icon-humidity.071ecb7e.svg";